exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .widget h3 {\n  text-align: center; }\n  .modal .widget h3 span {\n    color: #5387f7; }\n\n.modal .widget iframe {\n  display: block;\n  border: 1px solid #dadada !important;\n  margin: 10px auto; }\n\n.modal .modal-dialog .modal-header button span {\n  left: 0; }\n\n:host .modal-dialog {\n  width: 100%;\n  max-width: calc(100% - 1px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/editor/modals/widget-type.modal.component.scss
// module id = ../../../../../src/app/main/editor/modals/widget-type.modal.component.scss
// module chunks = 1